import { useSelector } from 'react-redux';
import { selectSiteTz } from '@store/selectors/site.selectors';
import { MOCK_SUBCONTRACTOR_PORTAL } from '@src/mocks/subcontractors';
import { ContractorHero } from './panels/ContractorHero';
import { TasksList } from './panels/TasksList';
import { IssuesAlerts } from './panels/IssuesAlerts';
import { ReportProgress } from './panels/ReportProgress';
import { DocumentsList } from './panels/DocumentsList';
import { WorkforceTable } from './panels/WorkforceTable';
import { MessagesCoordination } from './panels/MessagesCoordination';
import styles from './SubcontractorsPage.module.css';

export function SubcontractorsPage() {
  const data = MOCK_SUBCONTRACTOR_PORTAL;
  /* Every stamp on this page is site-relative. No default zone — the page waits
     for the working site rather than dating a subcontractor's tasks against a
     guess. */
  const tz = useSelector(selectSiteTz);
  if (!tz) return <div aria-busy="true" />;

  return (
    <div className={styles.page}>
      <ContractorHero contractor={data.subcontractor} tz={tz} />

      <div className={styles.grid}>
        <TasksList tasks={data.tasks} tz={tz} />
        <IssuesAlerts alerts={data.alerts} tz={tz} />
        <ReportProgress recentUpdates={data.recentUpdates} tz={tz} />
        <DocumentsList documents={data.documents} tz={tz} />
      </div>

      <WorkforceTable workforce={data.workforce} contractorName={data.subcontractor.name} />

      <MessagesCoordination messages={data.messages} tz={tz} />
    </div>
  );
}
